import { V4UUID } from '@/firebase/database';
import { Topic } from './topic';
import { Node } from './node';
import { NodeTemplate } from '../../store';
import { Message } from './message';
import { Service } from './service';
import {
  CustomPackageText,
  defaultCustomPkgText
} from '@/modules/codeViewModule/customCodeProcessing/processCustomPackageText';
import { LaunchFile } from '@/modules/controlCenterModule/components/robotConnection/loadLaunchFilesStrategy';
import { v4 } from 'uuid';
export class PackageT {
  name: string;
  id: V4UUID;
  nodes: Node[];
  topics: Topic[];
  nodeTemplates: NodeTemplate[];
  msgs: Message[];
  services: Service[];
  favouriteElems: Node[];
  robotPackage?: boolean;
  customText: CustomPackageText = { ...defaultCustomPkgText };
  launchFiles: LaunchFile[];
  description: string;
  constructor(
    name: string,
    id: V4UUID = v4(),
    robotPackage: boolean = false,
    nodes: Node[] = [],
    topics: Topic[] = [],
    nodeTemplates: NodeTemplate[] = [],
    msgs: Message[] = [],
    services: Service[] = [],
    favouriteElems: Node[] = [],
    customText: CustomPackageText | undefined = undefined,
    launchFiles: LaunchFile[] = [],
    description: string = 'No description found'
  ) {
    this.name = name;
    this.id = id;
    this.robotPackage = robotPackage;
    this.nodes = nodes;
    this.topics = topics;
    this.nodeTemplates = nodeTemplates;
    this.msgs = msgs;
    this.services = services;
    this.favouriteElems = favouriteElems;
    if (customText) this.customText = customText;
    this.launchFiles = launchFiles;
    this.description = description;
  }

  static fromJSON(jsonPackage: any): PackageT {
    // when the database generates items, it doesn't generate empty lists,
    // it just leaves them undefined
    if (jsonPackage.nodes)
      jsonPackage.nodes = jsonPackage.nodes.map((nodeData: any) =>
        Node.fromJSON(nodeData)
      );
    if (jsonPackage.topics)
      jsonPackage.topics = jsonPackage.topics.map((topicData: any) =>
        Topic.fromJSON(topicData)
      );
    if (jsonPackage.services)
      jsonPackage.services = jsonPackage.services.map((serviceData: any) =>
        Service.fromJSON(serviceData)
      );
    if (jsonPackage.msgs)
      jsonPackage.msgs = jsonPackage.msgs.map((msgData: any) =>
        Message.fromJSON(msgData)
      );

    return new PackageT(
      jsonPackage.name,
      jsonPackage.id || v4(),
      jsonPackage.robotPackage || false,
      jsonPackage.nodes || [],
      jsonPackage.topics || [],
      jsonPackage.nodeTemplates || [],
      jsonPackage.msgs || [],
      jsonPackage.services || [],
      jsonPackage.favouriteElems || [],
      jsonPackage.customText,
      jsonPackage.launchFiles || [],
      jsonPackage.description || 'No description found'
    );
  }
}
